import { createTheme } from '@mui/material/styles';

export const brand = {
  ink: '#1e1127',
  inkDeep: '#160b20',
  inkSoft: '#2c1f37',

  accent: '#9431f0',
  accentStrong: '#7c20c8',
  accentMuted: '#4b1d7f',

  page: '#F3F4F6',
  surface: '#FFFFFF',
  surfaceMuted: '#FAFBFC',
  surfaceSunken: '#F6F7F9',

  border: '#E5E7EB',
  borderSoft: '#EEF2F7',
  borderStrong: '#D1D5DB',

  textPrimary: '#111827',
  textSecondary: '#4B5563',
  textMuted: '#6B7280',
  textFaint: '#9CA3AF',

  onInkPrimary: '#FFFFFF',
  onInkMuted: '#D1D5DB',
  onInkFaint: '#9CA3AF',
} as const;

export const theme = createTheme({
  typography: {
    fontFamily: "'Libre Franklin', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    allVariants: {
      letterSpacing: 0,
    },
  },
  palette: {
    primary: {
      main: '#000f2c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#c2d8ff',
      contrastText: '#ffffff',
    },
    background: {
      default: '#000611',
    },
  },
  // Add more customization here
});
